import bid1 from '../assets/images/explore/bid1.png';
import bid2 from '../assets/images/explore/bid2.png';
import bid3 from '../assets/images/explore/bid3.png';

import profilePhoto01 from '../assets/images/messages/prof01.png';
import profilePhoto02 from '../assets/images/messages/prof02.png';
import profilePhoto03 from '../assets/images/messages/prof03.png';
import profilePhoto04 from '../assets/images/messages/prof04.png';
import profilePhoto05 from '../assets/images/messages/prof05.png';
import profilePhoto06 from '../assets/images/messages/prof06.png';
import profilePhoto07 from '../assets/images/messages/prof07.png';
import profilePhoto08 from '../assets/images/messages/prof08.png';
import myProfilePhoto from '../assets/images/messages/my_profile.png';







export interface recentActivityDataType {
    id: number,
    profLogo: string,
    activityTitle: string,
    time: string,
}

export const recentActivityData: recentActivityDataType[] = [
    {
        id: 1,
        profLogo: bid1,
        activityTitle: 'Liked  by Nft bank',
        time: '2022-06-26 08:08:08',
    },
    {
        id: 2,
        profLogo: bid2,
        activityTitle: 'Liked  by Jatinder Parmar',
        time: '2022-06-25 08:08:08',
    },
    {
        id: 3,
        profLogo: bid3,
        activityTitle: 'Liked  by Geasnder Gemar',
        time: '2022-06-24 08:08:08',
    },
    {
        id: 4,
        profLogo: bid1,
        activityTitle: 'Liked  by Nft bank',
        time: '2022-06-23 08:08:08',
    },
    {
        id: 5,
        profLogo: bid2,
        activityTitle: 'Liked  by Jatinder Parmar',
        time: '2022-06-22 08:08:08',
    },
    {
        id: 6,
        profLogo: bid3,
        activityTitle: 'Liked  by Geasnder Gemar',
        time: '2022-06-21 08:08:08',
    },
    {
        id: 7,
        profLogo: bid1,
        activityTitle: 'Liked  by Nft bank',
        time: '2022-06-20 08:08:08',
    },
    {
        id: 8,
        profLogo: bid2,
        activityTitle: 'Liked  by Jatinder Parmar',
        time: '2022-06-19 08:08:08',
    },
    {
        id: 9,
        profLogo: bid3,
        activityTitle: 'Liked  by Geasnder Gemar',
        time: '2022-06-18 08:08:08',
    },
    {
        id: 10,
        profLogo: bid1,
        activityTitle: 'Liked  by Nft bank',
        time: '2022-06-17 08:08:08',
    },
    {
        id: 11,
        profLogo: bid2,
        activityTitle: 'Liked  by Jatinder Parmar',
        time: '2022-06-16 08:08:08',
    },
    {
        id: 12,
        profLogo: bid3,
        activityTitle: 'Liked  by Geasnder Gemar',
        time: '2022-06-15 08:08:08',
    },
    {
        id: 13,
        profLogo: bid2,
        activityTitle: 'Liked  by Jatinder Parmar',
        time: '2022-06-14 08:08:08',
    },
    {
        id: 14,
        profLogo: bid3,
        activityTitle: 'Liked  by Geasnder Gemar',
        time: '2022-06-13 08:08:08',
    },
    {
        id: 15,
        profLogo: bid1,
        activityTitle: 'Liked  by Nft bank',
        time: '2022-06-12 08:08:08',
    },
    {
        id: 16,
        profLogo: bid2,
        activityTitle: 'Liked  by Jatinder Parmar',
        time: '2022-06-11 08:08:08',
    },
    {
        id: 17,
        profLogo: bid3,
        activityTitle: 'Liked  by Geasnder Gemar',
        time: '2022-06-10 08:08:08',
    },
]







export interface messagesDataType {
    id: number,
    name: string,
    isGroup: boolean,
    chatProfilePhoto?: string,
    groupProfilePhoto?: string[],
    // lastMessage: string,
    inboxMessages: {
        id: number,
        profilePhoto: string,
        profileName: string,
        messageText?: string,
        messagePhotoVideo?: {
            source: string,
            isVideo?: boolean,
            isVideoPlayOnPost?: boolean,
            videoSrc?: string,
            id: number,
        }[],
        messageGifs?: string,
        messageAudio?: string,

        messageSentTime: string,
        isItMyMessage: boolean,
    }[],
}


export const messagesData: messagesDataType[] = [
    {
        id: 1,
        name: 'Benjamin',
        isGroup: false,
        chatProfilePhoto: profilePhoto01,
        inboxMessages: [
            {
                id: 1,
                profilePhoto: profilePhoto01,
                profileName: 'Benjamin',
                messageText: 'Yo sup bro 👀',
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 2,
                profilePhoto: profilePhoto01,
                profileName: 'Benjamin',
                messageText: "What's your favorite NFTs?",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 3,
                profilePhoto: profilePhoto01,
                profileName: 'Benjamin',
                messageText: "Collection of 10,000 collectible NFTs launched",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 4,
                profilePhoto: profilePhoto01,
                profileName: 'Benjamin',
                messageText: "@blockmarktech & NFT advisors @Adelaide 👀",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 5,
                profilePhoto: myProfilePhoto,
                profileName: 'Donald Trump',
                messageText: "That's exactly how I felt. 😉",
                messageSentTime: '07.20 PM',
                isItMyMessage: true,
            },
            {
                id: 6,
                profilePhoto: profilePhoto01,
                profileName: 'Benjamin',
                messageText: "Meet the 7622 champions",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 7,
                profilePhoto: profilePhoto01,
                profileName: 'Benjamin',
                messageText: "Yo sup bro 👀",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 8,
                profilePhoto: profilePhoto01,
                profileName: 'Benjamin',
                messageText: "What's your favorite NFTs?",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 9,
                profilePhoto: profilePhoto01,
                profileName: 'Benjamin',
                messageText: "Collection of 10,000 collectible NFTs launched",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 10,
                profilePhoto: profilePhoto01,
                profileName: 'Benjamin',
                messageText: "https://media4.giphy.com/media/e0qWfWDuFDyaGM1GkP/giphy-preview.gif?cid=7b4b543fczrja2hr31rivsqrluk1xc7hhbqnoroq2plqzmq1&rid=giphy-preview.gif&ct=g",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
        ]

    },
    {
        id: 2,
        name: 'Ophelia',
        isGroup: false,
        chatProfilePhoto: profilePhoto02,
        inboxMessages: [
            {
                id: 1,
                profilePhoto: profilePhoto02,
                profileName: 'Ophelia',
                messageText: 'Yo sup bro 👀',
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 2,
                profilePhoto: profilePhoto02,
                profileName: 'Ophelia',
                messageText: "What's your favorite NFTs?",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 3,
                profilePhoto: profilePhoto02,
                profileName: 'Ophelia',
                messageText: "Collection of 10,000 collectible NFTs launched",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 4,
                profilePhoto: profilePhoto02,
                profileName: 'Ophelia',
                messageText: "@blockmarktech & NFT advisors @Adelaide 👀",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 5,
                profilePhoto: myProfilePhoto,
                profileName: 'Donald Trump',
                messageText: "That's exactly how I felt. 😉",
                messageSentTime: '07.20 PM',
                isItMyMessage: true,
            },
            {
                id: 6,
                profilePhoto: profilePhoto02,
                profileName: 'Ophelia',
                messageText: "Meet the 7622 champions",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 7,
                profilePhoto: profilePhoto02,
                profileName: 'Ophelia',
                messageText: "Yo sup bro 👀",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 8,
                profilePhoto: profilePhoto02,
                profileName: 'Ophelia',
                messageText: "What's your favorite NFTs?",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 9,
                profilePhoto: profilePhoto02,
                profileName: 'Ophelia',
                messageText: "Collection of 10,000 collectible NFTs launched",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 10,
                profilePhoto: profilePhoto02,
                profileName: 'Ophelia',
                messageText: "dssdfsdfsdf",
                messageSentTime: '07.20 PM',
                isItMyMessage: true,
            },
        ]

    },
    {
        id: 3,
        name: 'Charlie',
        isGroup: false,
        chatProfilePhoto: profilePhoto03,
        inboxMessages: [
            {
                id: 1,
                profilePhoto: profilePhoto03,
                profileName: 'Charlie',
                messageText: 'Yo sup bro 👀',
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 2,
                profilePhoto: profilePhoto03,
                profileName: 'Charlie',
                messageText: "What's your favorite NFTs?",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 3,
                profilePhoto: profilePhoto03,
                profileName: 'Charlie',
                messageText: "Collection of 10,000 collectible NFTs launched",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 4,
                profilePhoto: profilePhoto03,
                profileName: 'Charlie',
                messageText: "@blockmarktech & NFT advisors @Adelaide 👀",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 5,
                profilePhoto: myProfilePhoto,
                profileName: 'Donald Trump',
                messageText: "That's exactly how I felt. 😉",
                messageSentTime: '07.20 PM',
                isItMyMessage: true,
            },
            {
                id: 6,
                profilePhoto: profilePhoto03,
                profileName: 'Charlie',
                messageText: "Meet the 7622 champions",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 7,
                profilePhoto: profilePhoto03,
                profileName: 'Charlie',
                messageText: "Yo sup bro 👀",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 8,
                profilePhoto: profilePhoto03,
                profileName: 'Charlie',
                messageText: "What's your favorite NFTs?",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 9,
                profilePhoto: profilePhoto03,
                profileName: 'Charlie',
                messageText: "Collection of 10,000 collectible NFTs launched",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 10,
                profilePhoto: profilePhoto03,
                profileName: 'Charlie',
                messagePhotoVideo: [
                    {
                        source: 'https://images.unsplash.com/photo-1655825475769-f402505c329c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80',
                        id: 1,
                    }
                ],
                messageGifs: "https://media4.giphy.com/media/e0qWfWDuFDyaGM1GkP/giphy-preview.gif?cid=7b4b543fczrja2hr31rivsqrluk1xc7hhbqnoroq2plqzmq1&rid=giphy-preview.gif&ct=g",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
        ]

    },
    {
        id: 4,
        name: 'UNC Comunity Group',
        isGroup: true,
        groupProfilePhoto: [profilePhoto08, profilePhoto03],
        inboxMessages: [
            {
                id: 1,
                profilePhoto: profilePhoto01,
                profileName: 'Benjamin',
                messageText: 'Yo sup bro 👀',
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 2,
                profilePhoto: profilePhoto02,
                profileName: 'Ophelia',
                messageText: "What's your favorite NFTs?",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 3,
                profilePhoto: profilePhoto03,
                profileName: 'Charlie',
                messageText: "Collection of 10,000 collectible NFTs launched",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 4,
                profilePhoto: profilePhoto04,
                profileName: 'Adelaide',
                messageText: "@blockmarktech & NFT advisors @Adelaide 👀",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 5,
                profilePhoto: myProfilePhoto,
                profileName: 'Donald Trump',
                messageText: "That's exactly how I felt. 😉",
                messageSentTime: '07.20 PM',
                isItMyMessage: true,
            },
            {
                id: 6,
                profilePhoto: profilePhoto05,
                profileName: 'Adelaide',
                messageText: "Meet the 7622 champions",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 7,
                profilePhoto: profilePhoto06,
                profileName: 'Benjamin',
                messageText: "Yo sup bro 👀",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 8,
                profilePhoto: profilePhoto07,
                profileName: 'Ophelia',
                messageText: "What's your favorite NFTs?",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 9,
                profilePhoto: profilePhoto08,
                profileName: 'Charlie',
                messageText: "Collection of 10,000 collectible NFTs launched",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 10,
                profilePhoto: profilePhoto08,
                profileName: 'Charlie',
                messageGifs: "https://media4.giphy.com/media/e0qWfWDuFDyaGM1GkP/giphy-preview.gif?cid=7b4b543fczrja2hr31rivsqrluk1xc7hhbqnoroq2plqzmq1&rid=giphy-preview.gif&ct=g",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
        ]

    },
    {
        id: 5,
        name: 'Adelaide',
        isGroup: false,
        chatProfilePhoto: profilePhoto04,
        inboxMessages: [
            {
                id: 1,
                profilePhoto: profilePhoto04,
                profileName: 'Adelaide',
                messageText: 'Yo sup bro 👀',
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 2,
                profilePhoto: profilePhoto04,
                profileName: 'Adelaide',
                messageText: "What's your favorite NFTs?",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 3,
                profilePhoto: profilePhoto04,
                profileName: 'Adelaide',
                messageText: "Collection of 10,000 collectible NFTs launched",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 4,
                profilePhoto: profilePhoto04,
                profileName: 'Adelaide',
                messageText: "@blockmarktech & NFT advisors @Adelaide 👀",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 5,
                profilePhoto: myProfilePhoto,
                profileName: 'Donald Trump',
                messageText: "That's exactly how I felt. 😉",
                messageSentTime: '07.20 PM',
                isItMyMessage: true,
            },
            {
                id: 6,
                profilePhoto: profilePhoto04,
                profileName: 'Adelaide',
                messageText: "Meet the 7622 champions",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 7,
                profilePhoto: profilePhoto04,
                profileName: 'Adelaide',
                messageText: "Yo sup bro 👀",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 8,
                profilePhoto: profilePhoto04,
                profileName: 'Adelaide',
                messageText: "What's your favorite NFTs?",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 9,
                profilePhoto: profilePhoto04,
                profileName: 'Adelaide',
                messageText: "Collection of 10,000 collectible NFTs launched",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 10,
                profilePhoto: profilePhoto04,
                profileName: 'Adelaide',
                messageGifs: "https://media4.giphy.com/media/e0qWfWDuFDyaGM1GkP/giphy-preview.gif?cid=7b4b543fczrja2hr31rivsqrluk1xc7hhbqnoroq2plqzmq1&rid=giphy-preview.gif&ct=g",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
        ]

    },
    {
        id: 6,
        name: 'Adelaide 2',
        isGroup: false,
        chatProfilePhoto: profilePhoto05,
        inboxMessages: [
            {
                id: 1,
                profilePhoto: profilePhoto05,
                profileName: 'Adelaide 2',
                messageText: 'Yo sup bro 👀',
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 2,
                profilePhoto: profilePhoto05,
                profileName: 'Adelaide 2',
                messageText: "What's your favorite NFTs?",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 3,
                profilePhoto: profilePhoto05,
                profileName: 'Adelaide 2',
                messageText: "Collection of 10,000 collectible NFTs launched",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 4,
                profilePhoto: profilePhoto05,
                profileName: 'Adelaide 2',
                messageText: "@blockmarktech & NFT advisors @Adelaide 2 👀",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 5,
                profilePhoto: myProfilePhoto,
                profileName: 'Donald Trump',
                messageText: "That's exactly how I felt. 😉",
                messageSentTime: '07.20 PM',
                isItMyMessage: true,
            },
            {
                id: 6,
                profilePhoto: profilePhoto05,
                profileName: 'Adelaide 2',
                messageText: "Meet the 7622 champions",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 7,
                profilePhoto: profilePhoto05,
                profileName: 'Adelaide 2',
                messageText: "Yo sup bro 👀",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 8,
                profilePhoto: profilePhoto05,
                profileName: 'Adelaide 2',
                messageText: "What's your favorite NFTs?",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 9,
                profilePhoto: profilePhoto05,
                profileName: 'Adelaide 2',
                messageText: "Collection of 10,000 collectible NFTs launched",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 10,
                profilePhoto: profilePhoto05,
                profileName: 'Adelaide 2',
                messageGifs: "https://media4.giphy.com/media/e0qWfWDuFDyaGM1GkP/giphy-preview.gif?cid=7b4b543fczrja2hr31rivsqrluk1xc7hhbqnoroq2plqzmq1&rid=giphy-preview.gif&ct=g",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
        ]

    },
    {
        id: 7,
        name: 'Papa',
        isGroup: false,
        chatProfilePhoto: profilePhoto06,
        inboxMessages: [
            {
                id: 1,
                profilePhoto: profilePhoto06,
                profileName: 'Papa',
                messageText: 'Yo sup bro 👀',
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 2,
                profilePhoto: profilePhoto06,
                profileName: 'Papa',
                messageText: "What's your favorite NFTs?",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 3,
                profilePhoto: profilePhoto06,
                profileName: 'Papa',
                messageText: "Collection of 10,000 collectible NFTs launched",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 4,
                profilePhoto: profilePhoto06,
                profileName: 'Papa',
                messageText: "@blockmarktech & NFT advisors @Papa 👀",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 5,
                profilePhoto: myProfilePhoto,
                profileName: 'Donald Trump',
                messageText: "That's exactly how I felt. 😉",
                messageSentTime: '07.20 PM',
                isItMyMessage: true,
            },
            {
                id: 6,
                profilePhoto: profilePhoto06,
                profileName: 'Papa',
                messageText: "Meet the 7622 champions",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 7,
                profilePhoto: profilePhoto06,
                profileName: 'Papa',
                messageText: "Yo sup bro 👀",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 8,
                profilePhoto: profilePhoto06,
                profileName: 'Papa',
                messageText: "What's your favorite NFTs?",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 9,
                profilePhoto: profilePhoto06,
                profileName: 'Papa',
                messageText: "Collection of 10,000 collectible NFTs launched",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 10,
                profilePhoto: profilePhoto06,
                profileName: 'Papa',
                messageGifs: "https://media4.giphy.com/media/e0qWfWDuFDyaGM1GkP/giphy-preview.gif?cid=7b4b543fczrja2hr31rivsqrluk1xc7hhbqnoroq2plqzmq1&rid=giphy-preview.gif&ct=g",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
        ]

    },
    {
        id: 8,
        name: 'Ranky',
        isGroup: false,
        chatProfilePhoto: profilePhoto07,
        inboxMessages: [
            {
                id: 1,
                profilePhoto: profilePhoto07,
                profileName: 'Ranky',
                messageText: 'Yo sup bro 👀',
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 2,
                profilePhoto: profilePhoto07,
                profileName: 'Ranky',
                messageText: "What's your favorite NFTs?",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 3,
                profilePhoto: profilePhoto07,
                profileName: 'Ranky',
                messageText: "Collection of 10,000 collectible NFTs launched",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 4,
                profilePhoto: profilePhoto07,
                profileName: 'Ranky',
                messageText: "@blockmarktech & NFT advisors @Ranky 👀",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 5,
                profilePhoto: myProfilePhoto,
                profileName: 'Donald Trump',
                messageText: "That's exactly how I felt. 😉",
                messageSentTime: '07.20 PM',
                isItMyMessage: true,
            },
            {
                id: 6,
                profilePhoto: profilePhoto07,
                profileName: 'Ranky',
                messageText: "Meet the 7622 champions",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 7,
                profilePhoto: profilePhoto07,
                profileName: 'Ranky',
                messageText: "Yo sup bro 👀",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 8,
                profilePhoto: profilePhoto07,
                profileName: 'Ranky',
                messageText: "What's your favorite NFTs?",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 9,
                profilePhoto: profilePhoto07,
                profileName: 'Ranky',
                messageText: "Collection of 10,000 collectible NFTs launched",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 10,
                profilePhoto: profilePhoto07,
                profileName: 'Ranky',
                messageGifs: "https://media4.giphy.com/media/e0qWfWDuFDyaGM1GkP/giphy-preview.gif?cid=7b4b543fczrja2hr31rivsqrluk1xc7hhbqnoroq2plqzmq1&rid=giphy-preview.gif&ct=g",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
        ]

    },
    {
        id: 9,
        name: 'Ali',
        isGroup: false,
        chatProfilePhoto: profilePhoto08,
        inboxMessages: [
            {
                id: 1,
                profilePhoto: profilePhoto08,
                profileName: 'Ali',
                messageText: 'Yo sup bro 👀',
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 2,
                profilePhoto: profilePhoto08,
                profileName: 'Ali',
                messageText: "What's your favorite NFTs?",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 3,
                profilePhoto: profilePhoto08,
                profileName: 'Ali',
                messageText: "Collection of 10,000 collectible NFTs launched",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 4,
                profilePhoto: profilePhoto08,
                profileName: 'Ali',
                messageText: "@blockmarktech & NFT advisors @Ali 👀",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 5,
                profilePhoto: myProfilePhoto,
                profileName: 'Donald Trump',
                messageText: "That's exactly how I felt. 😉",
                messageSentTime: '07.20 PM',
                isItMyMessage: true,
            },
            {
                id: 6,
                profilePhoto: profilePhoto08,
                profileName: 'Ali',
                messageText: "Meet the 7622 champions",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 7,
                profilePhoto: profilePhoto08,
                profileName: 'Ali',
                messageText: "Yo sup bro 👀",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 8,
                profilePhoto: profilePhoto08,
                profileName: 'Ali',
                messageText: "What's your favorite NFTs?",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 9,
                profilePhoto: profilePhoto08,
                profileName: 'Ali',
                messageText: "Collection of 10,000 collectible NFTs launched",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 10,
                profilePhoto: profilePhoto08,
                profileName: 'Ali',
                messageGifs: "https://media4.giphy.com/media/e0qWfWDuFDyaGM1GkP/giphy-preview.gif?cid=7b4b543fczrja2hr31rivsqrluk1xc7hhbqnoroq2plqzmq1&rid=giphy-preview.gif&ct=g",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
        ]

    },
    {
        id: 10,
        name: 'UNC Comunity Group',
        isGroup: true,
        groupProfilePhoto: [profilePhoto08, profilePhoto03],
        inboxMessages: [
            {
                id: 1,
                profilePhoto: profilePhoto01,
                profileName: 'Benjamin',
                messageText: 'Yo sup bro 👀',
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 2,
                profilePhoto: profilePhoto02,
                profileName: 'Ophelia',
                messageText: "What's your favorite NFTs?",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 3,
                profilePhoto: profilePhoto03,
                profileName: 'Charlie',
                messageText: "Collection of 10,000 collectible NFTs launched",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 4,
                profilePhoto: profilePhoto04,
                profileName: 'Adelaide',
                messageText: "@blockmarktech & NFT advisors @Adelaide 👀",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 5,
                profilePhoto: myProfilePhoto,
                profileName: 'Donald Trump',
                messageText: "That's exactly how I felt. 😉",
                messageSentTime: '07.20 PM',
                isItMyMessage: true,
            },
            {
                id: 6,
                profilePhoto: profilePhoto05,
                profileName: 'Adelaide',
                messageText: "Meet the 7622 champions",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 7,
                profilePhoto: profilePhoto06,
                profileName: 'Benjamin',
                messageText: "Yo sup bro 👀",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 8,
                profilePhoto: profilePhoto07,
                profileName: 'Ophelia',
                messageText: "What's your favorite NFTs?",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 9,
                profilePhoto: profilePhoto08,
                profileName: 'Charlie',
                messageText: "Collection of 10,000 collectible NFTs launched",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
            {
                id: 10,
                profilePhoto: profilePhoto08,
                profileName: 'Charlie',
                messageGifs: "https://media4.giphy.com/media/e0qWfWDuFDyaGM1GkP/giphy-preview.gif?cid=7b4b543fczrja2hr31rivsqrluk1xc7hhbqnoroq2plqzmq1&rid=giphy-preview.gif&ct=g",
                messageSentTime: '07.20 PM',
                isItMyMessage: false,
            },
        ]

    },
]







export interface followingDataType {
    id: number,
    profilePhoto: string,
    profileName: string,
    followers: string,
    isFollowing: boolean,
}



export const followingData: followingDataType[] = [
    {
        id: 1,
        profilePhoto: profilePhoto01,
        profileName: 'Nft bank',
        followers: '2K',
        isFollowing: false,
    },
    {
        id: 2,
        profilePhoto: profilePhoto02,
        profileName: 'Jatinder Parmar',
        followers: '200',
        isFollowing: true,
    },
    {
        id: 3,
        profilePhoto: profilePhoto03,
        profileName: 'Geasnder Gemar',
        followers: '8K',
        isFollowing: false,
    },
    {
        id: 4,
        profilePhoto: profilePhoto01,
        profileName: 'Nft bank',
        followers: '2K',
        isFollowing: false,
    },
    {
        id: 5,
        profilePhoto: profilePhoto02,
        profileName: 'Jatinder Parmar',
        followers: '200',
        isFollowing: true,
    },
    {
        id: 6,
        profilePhoto: profilePhoto03,
        profileName: 'Geasnder Gemar',
        followers: '8K',
        isFollowing: false,
    },
    {
        id: 7,
        profilePhoto: profilePhoto01,
        profileName: 'Nft bank',
        followers: '2K',
        isFollowing: false,
    },
    {
        id: 8,
        profilePhoto: profilePhoto02,
        profileName: 'Jatinder Parmar',
        followers: '200',
        isFollowing: true,
    },
    {
        id: 9,
        profilePhoto: profilePhoto03,
        profileName: 'Geasnder Gemar',
        followers: '8K',
        isFollowing: false,
    },
    {
        id: 10,
        profilePhoto: profilePhoto01,
        profileName: 'Nft bank',
        followers: '2K',
        isFollowing: false,
    },
    {
        id: 11,
        profilePhoto: profilePhoto02,
        profileName: 'Jatinder Parmar',
        followers: '200',
        isFollowing: true,
    },
    {
        id: 12,
        profilePhoto: profilePhoto03,
        profileName: 'Geasnder Gemar',
        followers: '8K',
        isFollowing: false,
    },
    {
        id: 13,
        profilePhoto: profilePhoto01,
        profileName: 'Nft bank',
        followers: '2K',
        isFollowing: false,
    },
    {
        id: 14,
        profilePhoto: profilePhoto02,
        profileName: 'Jatinder Parmar',
        followers: '200',
        isFollowing: true,
    },
    {
        id: 15,
        profilePhoto: profilePhoto03,
        profileName: 'Geasnder Gemar',
        followers: '8K',
        isFollowing: false,
    },
    {
        id: 16,
        profilePhoto: profilePhoto01,
        profileName: 'Nft bank',
        followers: '2K',
        isFollowing: false,
    },
    {
        id: 17,
        profilePhoto: profilePhoto02,
        profileName: 'Jatinder Parmar',
        followers: '200',
        isFollowing: true,
    },
    {
        id: 18,
        profilePhoto: profilePhoto03,
        profileName: 'Geasnder Gemar',
        followers: '8K',
        isFollowing: false,
    },
]
